import { POIPASENGER } from "../../actions/portal/";

export default function(state = null, action) {
  switch (action.type) {
    case POIPASENGER:
      return action.payload;
    default:
  }

  return state;
}
